/* eslint-disable react/button-has-type */
/**
 *
 * Carousel
 *
 */

import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import _classNames from 'classnames';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import withSizes from 'react-sizes';
import { isBot } from 'utils/stringUtils';
import './styles.css';
import useAriaHiddenFix from 'components/Hooks/useAriaHiddenFix';
import ArrowLeft from './images/arrow-left.svg';
import ArrowRight from './images/arrow-right.svg';

const CustomLeftArrow = ({ onClick, centerMode }) => (
  <button
    onClick={() => onClick()}
    className={_classNames('custom-left-arrow', {
      'custom-left-arrow-center-mode': centerMode,
    })}
  >
    <img src={ArrowLeft} alt="Arrow Left" />
  </button>
);
const CustomRightArrow = ({ onClick, centerMode }) => (
  <button
    onClick={() => onClick()}
    className={_classNames('custom-right-arrow', {
      'custom-right-arrow-center-mode': centerMode,
    })}
  >
    <img src={ArrowRight} alt="Arrow Right" />
  </button>
);

function CMCarousel(props) {
  const {
    children,
    responsive,
    customProps,
    slideToShow,
    isMobile,
    isTablet,
    infinite,
  } = props;
  const carouselContainerRef = useRef(null);
  useAriaHiddenFix(carouselContainerRef);
  let finalSlideToShow = slideToShow;
  const bot = isBot();
  if (!slideToShow) {
    if (isMobile) {
      finalSlideToShow = 1;
    } else if (isTablet) {
      finalSlideToShow = 2;
    } else {
      finalSlideToShow = 4;
    }
  }
  return (
    <div ref={carouselContainerRef}>
      <Carousel
        additionalTransfrom={0}
        arrows
        customLeftArrow={!bot ? <CustomLeftArrow {...customProps} /> : null}
        customRightArrow={!bot ? <CustomRightArrow {...customProps} /> : null}
        containerClass="cm-carousel-container"
        dotListClass=""
        draggable
        focusOnSelect={false}
        itemClass="cm-carousel-item"
        keyBoardControl
        minimumTouchDrag={80}
        renderDotsOutside={false}
        showDots={false}
        sliderClass=""
        slidesToSlide={finalSlideToShow}
        swipeable
        infinite={infinite}
        responsive={responsive}
        {...customProps}
      >
        {children}
      </Carousel>
    </div>
  );
}

CMCarousel.propTypes = {
  children: PropTypes.node.isRequired,
  responsive: PropTypes.object,
  slideToShow: PropTypes.number,
  isMobile: PropTypes.bool,
  isTablet: PropTypes.bool,
  infinite: PropTypes.bool,
};

CMCarousel.defaultProps = {
  responsive: {
    desktop: {
      breakpoint: {
        max: 3000,
        min: 1024,
      },
      items: 4,
      partialVisibilityGutter: 40,
    },
    mobile: {
      breakpoint: {
        max: 600,
        min: 0,
      },
      items: 1,
      partialVisibilityGutter: 30,
    },
    tablet: {
      breakpoint: {
        max: 1024,
        min: 600,
      },
      items: 2,
      partialVisibilityGutter: 30,
    },
  },
  infinite: true,
};
const mapSizesToProps = ({ width }) => ({
  isMobile: width <= 480,
  isTablet: width <= 1024,
});

export default withSizes(mapSizesToProps)(CMCarousel);
